import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=57c15e5f&scoped=true&"
import script from "./PricingSection.vue?vue&type=script&lang=js&"
export * from "./PricingSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingSection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PricingSection.vue?vue&type=style&index=1&id=57c15e5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c15e5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDivider,VImg,VRow})
